// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Public_Sans_7dd612', '__Public_Sans_Fallback_7dd612', Helvetica, Arial, sans-serif","fontStyle":"normal"},"className":"__className_7dd612"};